<ng-template #modalDiv style="top:20%;">
  <div class="modal-header" >{{header}}
  </div>
  <div class="modal-body">
    {{message}}
    <ng-content></ng-content>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">OK</button>
  </div>
</ng-template>
